import { useSelector } from "react-redux";
import { enterpriseLevelsDetailsSelector } from "../Reducers/enterpriseLevelsDetailsReducer";
import {
  ON_TIME_BUFFER_MINUTES,
  ON_TIME_BUFFER_ENTERPRISE_IDS,
} from "../hardcode";

const resolveOnTimeBufferMinutes = (enterpriseId) =>
  ON_TIME_BUFFER_ENTERPRISE_IDS.includes(Number(enterpriseId))
    ? ON_TIME_BUFFER_MINUTES
    : 0;

/**
 * On-time grace buffer (minutes) for the loaded enterprise, keyed on its root
 * id so it's independent of the logged-in admin's level. Returns 0 until the
 * structure loads or for unbuffered enterprises.
 *
 * Single source of truth on the frontend: sent to the backend as
 * `onTimeBufferMinutes` and used by badge renderers so display and reports stay
 * consistent.
 *
 * @returns {number}
 */
export function useOnTimeBufferMinutes() {
  const enterpriseLevels = useSelector(enterpriseLevelsDetailsSelector);
  const enterpriseId = enterpriseLevels?.getEnterprise?.()?.getId?.();
  return resolveOnTimeBufferMinutes(enterpriseId);
}
